import loadable from '@loadable/component';

export const MarieclaireusshopSiteWrapper = loadable(
  () => import(/* webpackChunkName: "marieclaireusshop-site" */ './MarieclaireusshopSiteWrapper'),
);
